var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_20489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10208 3.60534C6.94674 2.09068 7.36874 1.33334 8.00008 1.33334C8.63141 1.33334 9.05341 2.09068 9.89808 3.60534L10.1167 3.99734C10.3567 4.42801 10.4767 4.64334 10.6634 4.78534C10.8501 4.92734 11.0834 4.98001 11.5501 5.08534L11.9741 5.18134C13.6141 5.55268 14.4334 5.73801 14.6287 6.36534C14.8234 6.99201 14.2647 7.64601 13.1467 8.95334L12.8574 9.29134C12.5401 9.66268 12.3807 9.84868 12.3094 10.078C12.2381 10.308 12.2621 10.556 12.3101 11.0513L12.3541 11.5027C12.5227 13.2473 12.6074 14.1193 12.0967 14.5067C11.5861 14.8947 10.8181 14.5407 9.28341 13.834L8.88541 13.6513C8.44941 13.45 8.23141 13.35 8.00008 13.35C7.76874 13.35 7.55074 13.45 7.11474 13.6513L6.71741 13.834C5.18208 14.5407 4.41408 14.894 3.90408 14.5073C3.39274 14.1193 3.47741 13.2473 3.64608 11.5027L3.69008 11.052C3.73808 10.556 3.76208 10.308 3.69008 10.0787C3.61941 9.84868 3.46008 9.66268 3.14274 9.29201L2.85341 8.95334C1.73541 7.64668 1.17674 6.99268 1.37141 6.36534C1.56674 5.73801 2.38674 5.55201 4.02674 5.18134L4.45074 5.08534C4.91674 4.98001 5.14941 4.92734 5.33674 4.78534C5.52341 4.64334 5.64341 4.42801 5.88341 3.99734L6.10208 3.60534Z",
    stroke: "#DA9A38",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_20489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4);
export default __webpack_public_path__ + "static/media/star4.ebeb8a20f9ae624ab4682f808852e383.svg";
export { ForwardRef as ReactComponent };